module.exports = __webpack_public_path__ + "images/emoji/crying_cat_face.be3f02c20d68cf2b2c92.png";